module.exports = __webpack_public_path__ + "static/media/edit-icon.e5f2ee62.svg";